import { create } from "zustand";

const initialState = {
  amountPopup: {
    popupClicked: false,
    displayPopup: false,
    popupEnabled: window.checkout_popup?.amount_upsell_toggle,
  },
};

export const usePopupStore = create((set, get) => ({
  ...initialState,
  enableAmontUpsellPopup: () => {
    set((state) => ({
      ...state,
      amountPopup: {
        ...state.amountPopup,
        displayPopup: true,
      },
    }));
  },
  disableUpellPopup: () =>
    set((state) => ({
      ...state,
      amountPopup: {
        ...state.amountPopup,
        popupClicked: true,
        displayPopup: false,
      },
    })),
}));
